export const calculateDays = (expirationDate: any) => {
  const endDate: any = new Date(expirationDate);
  const startDate: any = new Date();

  const diffInMs: any = endDate - startDate;
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

  return Math.ceil(diffInDays);
};

export enum AlertType {
  WARNING = 'warning',
  EXPIRED = 'danger',
  GRACEPERIOD = 'custom',
  EXPIREDWITHORG = 'expiredwithorg',
}

export const TRY_NEW_FEATURES_VALUES = [
  {
    label: 'Normalize NDC Codes',
    value: 'NORMALIZE_NDC_CODES',
    selected: false,
  },
  {
    label: 'Generics for Brand Names',
    value: 'GENERICS_FOR_BRAND_NAMES',
    selected: false,
  },
  {
    label: 'Body Parts for Conditions',
    value: 'BODY_PARTS_FOR_CONDITIONS',
    selected: false,
  },
];

export const removeTags = (str) => {
  if (str === null || str === '') return '';
  else str = str.toString();
  return str.replace(/(<([^>]+)>)/gi, '');
};

export const formatDate = (date) => {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();
  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;
  return [year, month, day].join('-');
};

export const convertToEpochTime = (days: number) => Date.now() - days * 24 * 60 * 60 * 1000;
